module.exports = __webpack_public_path__ + "img/Add-to-cart.7e5f7f3.png";